import templateStr from 'text!./templates/billing-line-policies-summary.html';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            gwBillingPaymentLinePoliciesSummary: '='
        },
        controller: [function () {}]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/billing/directives/BillingLinePoliciesSummary.js
// module id = 1401
// module chunks = 0